/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { YookassaPaymentMethod } from "../../entities/yookassa/PaymentMethod";
import { z } from "zod/v4";

export const yookassaPaymentMethodSchema = z.object({
    "type": z.optional(z.string())
    }) as unknown as z.ZodType<YookassaPaymentMethod>